import { render, staticRenderFns } from "./OurWorkComponent3.vue?vue&type=template&id=021a3e09&scoped=true&"
import script from "./OurWorkComponent3.vue?vue&type=script&lang=js&"
export * from "./OurWorkComponent3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a3e09",
  null
  
)

export default component.exports